import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function About() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">About SMNS</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li>Welcome to St. Mary’s Nursery School, Bokaro</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Welcome to St. Mary’s Nursery School, Bokaro</h1>
                            <p><b><i>Where Little Steps Lead to Lifelong Learning!</i></b></p>
                            <p>
                                At <b>St. Mary’s Nursery School (SMNS), Bokaro,</b> we believe that every child’s first experience of school should be filled with joy, curiosity, and care. An <b>English Medium Co-educational Institution,</b> SMNS functions under the aegis of <b>St. Thomas Orthodox Church Mission, Bhilai, Chhattisgarh,</b> and is guided by the values of the
                                <b>Indian Orthodox Church.</b>
                            </p>
                            <p>Founded by <b>Late Lamented H. G. Dr. Stephanos Mar Theodosius,</b> an eminent educationist and visionary, the school continues to grow under the blessings and guidance of <b>H. G. Alexios Mar Eusebius,</b> our esteemed President.</p>
                            <p>At SMNS, we take pride in creating a <b>safe, vibrant, and technology-enabled learning environment </b>equipped with <b>smart classrooms, RO purified water, a full-time power backup</b>, and a <b>1:15 teacher-student ratio.</b> Our <b>NEP-based play-way methodology, bagless Fridays,</b> and emphasis on <b>holistic development</b> ensure that every child learns with happiness and confidence.</p>
                            <p>We strive to nurture <b>responsible and reasonable citizens</b> curious thinkers, kind friends, and joyful learners ready to take on the world with courage and compassion.</p>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default About